module.exports = __webpack_public_path__ + "static/open-road-95a9f72689d62ee4d9e630c712ed56fd.jpg";